import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalWorkflowListForNRO = lazy(() =>
  import("@scenes/ConversationalWorkflowList").then((module) => ({
    default: module.ConversationalWorkflowList,
  }))
);

export const conversationalNRO: NavigationRoutingObject = {
  Component: ConversationalWorkflowListForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  icon: "nav-system-sms",
  heading: (t: I18nT<"dashboard-navigation">) => t("conversational-workflows-nro-heading", "Conversational Agents"),
  pageNameForTracking: () => "Conversational Workflows",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("conversational-workflows-nro-description", "Manage conversational workflows and routing"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
